import React from 'react'
import { Box } from '@mui/material'
import { Brand } from 'src/types'

type Props = {
  brand: Brand
  productNumber: string
}

export const YsrCaution: React.FC<Props> = ({ brand, productNumber }) => {
  const isYsr = brand === 'yellStory'
  const isYsrRegularBankLacingModel = isYsr && ['2B041', 'SS016'].includes(productNumber)
  if (!isYsrRegularBankLacingModel) return <></>
  return <Box color={'red'}>こちらのモデルは、土手巻きが順巻きです。</Box>
}
